// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__il0Lb","collapse_arrow_icon":"styles_collapse_arrow_icon__3+92J"};